<template>
<div class="chapter">
<div class="inner_page">
<h2 id="DedicationPage" title="Dedication"></h2>
<p class="dedication">To the first…<br/>
  Walter Harper, an Alaska Native in 1913. He was joined by the mountaineering team co-led by Hudson Stuck and Harry Karstens, and included Robert Tatum.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?64737031